import { Component, OnInit, ViewEncapsulation, ElementRef, AfterViewChecked, Output, EventEmitter, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentApiClient } from '../../services/content-service';
import { Utilities } from '../../shared/utilities';
import { QueryParamService, Core } from '../../shared/core/ovs.core';
import { ResortApplicationConfiguration } from '../../models/presentation.model';
import { BenefitAmount } from './benefit-amount.model';
import { EnvironmentConfiguration } from '../../configuration/environment-configuration.model';
import { EnvironmentConfigurationService } from '../../services/environment-configuration.service';

@Component({
  selector: 'ocean-upgrade',
  templateUrl: './ocean-upgrade.component.html',
})
export class OceanUpgradeComponent implements OnInit {

  data: SafeHtml;
  private cssUrl: "https://oceanpopup-wa-dev-usw2.azurewebsites.net/upsellContent/style?partnerId=147&memberClassId=1505&product=hotel&locale=en-us";

  static isCssLoaded = false;
  private get memberClassId(): string {
    return (<ResortApplicationConfiguration>Core.current.currentConfiguration).MemberClassId;
  }

  private get upgradeMemberClassId(): string {
    return (<ResortApplicationConfiguration>Core.current.currentConfiguration).UpgradeMemberClassId;
  }

  private get partnerId(): string {
    return this.qryParamService.partnerId();
  }
  @Input() benefitAmount: BenefitAmount = <BenefitAmount>{ withCurrentMembership: 31, withUpgradedMembership: 63 };
  @Output() book: EventEmitter<any> = new EventEmitter();
  @Output() close: EventEmitter<any> = new EventEmitter();
  @Output() upgrade: EventEmitter<any> = new EventEmitter();

  private _loadedMarkup = false;
  private _eventBindingSetup = false;

  constructor(private domSanitizer: DomSanitizer,
    private contentService: ContentApiClient,
    private elRef: ElementRef,
    private qryParamService: QueryParamService,
    private configService: EnvironmentConfigurationService) {

  }

  ngOnInit() {

    if (!OceanUpgradeComponent.isCssLoaded) {
      Utilities.addStyleSheet(`${this.configService.configuration.contentApiConfiguration.rootUrl}/upsellContent/style?partnerId=${this.partnerId}&memberClassId=${this.memberClassId}&product=resort&locale=en-us`,
        () => { console.log('loaded: +' + this.cssUrl) });
      OceanUpgradeComponent.isCssLoaded = true;
    }
    
    this.contentService.getContent({
      partnerId: this.partnerId
      , memberClassId: this.memberClassId
      , upgradeMemberClassId: this.upgradeMemberClassId
      , benefitAmount: this.benefitAmount
    }, (v) => this.onContentReceived(v));
  }

  onContentReceived(viewSnippet: string) {
    this.data = this.domSanitizer.bypassSecurityTrustHtml(viewSnippet);
    this._loadedMarkup = true;
    this._eventBindingSetup = false;
  }

  ngAfterViewChecked() {
    if (this._loadedMarkup && !this._eventBindingSetup) {
      var upgradeButton = this.elRef.nativeElement.querySelector('.button-upgrade')
      if (upgradeButton) {
        upgradeButton.removeEventListener('click', this.upgradeClicked, { passive: true });
        upgradeButton.addEventListener('click', this.upgradeClicked.bind(this));
      }
      var bookButton = this.elRef.nativeElement.querySelector('.button-book')
      if (bookButton) {
        bookButton.removeEventListener('click', this.bookClicked, { passive: true });
        bookButton.addEventListener('click', this.bookClicked.bind(this));
      }
      var closeButton = this.elRef.nativeElement.querySelector('.button-close')
      if (closeButton) {
        closeButton.removeEventListener('click', this.closeClicked, { passive: true });
        closeButton.addEventListener('click', this.closeClicked.bind(this));
      }
      this._eventBindingSetup = true;
    }
  }

  bookClicked() {
    this.book.emit();
  }

  upgradeClicked() {
    this.upgrade.emit();
  }

  closeClicked() {
    this.close.emit();
  }


}




// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/room-availability/ocean-upgrade/ocean-upgrade.component.ts